import styled, { ThemeProvider } from 'styled-components'
// import { GlobalVariables } from 'Globals/GlobalVariables'
import { ReactElement } from 'react'
import List from 'components/List'
import Summary from 'components/Summary'
import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import MiniHeader from 'components/MiniHeader'
import { TextWidth } from "@ta-interaktiv/react-disco-grid";

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {

  const theme = {
    typography: {
      size: {
        s: '1.2rem',
        m: '1.4rem',
        l: '1.6rem',
        xl: '2.4rem',
      }
    },
    textColor: colorMode === 'dark' ? '#eeeeee' : '#121212',
    textColorInverted: colorMode === 'dark' ? '#121212' : '#eeeeee',
    textGrey: colorMode === 'dark' ? '#ffffff' : '#202346',
    buttonColor: colorMode === 'dark' ? '#eaeaea' : '#eaeaea',
    buttonTextColor: colorMode === 'dark' ? '#202346' : '#ffffff',
    siteBackground: colorMode === 'dark' ? '#121212' : '#ffffff',
    backgroundColor: colorMode === 'dark' ? '#27252e' : '#27252e',
    backgroundColorLight: colorMode === 'dark' ? '#27252e' : '#27252e',
    backgroundColorDark: colorMode === 'dark' ? '#1c2939' : '#1c2939',
    backgroundColorDark1: colorMode === 'dark' ? '#192432' : '#192432',
    backgroundColorDarker: colorMode === 'dark' ? '#173152' : '#173152',
    colorMain: colorMode === 'dark' ? '#ff585b' : '#aa0a0c',
    colorMainLight: colorMode === 'dark' ? '#ffc979' : '#ffc979',
    grayColor: colorMode === 'dark' ? '#333333' : '#e2e3e5',
    blue: colorMode === 'dark' ? '#202346' : '#202346',
    chartGridColorX: colorMode === 'dark' ? '#333344' : '#eeeeee',
    chartGridColorY: colorMode === 'dark' ? '#444455' : '#cccccc',
    textWhite: colorMode === 'dark' ? '#ffffffdd' : '#ffffffdd',
    colorMode: colorMode,
    brandColor:
      tenant.key === '24heures'
        ? colorMode == 'dark'
          ? '#f65861'
          : '#d9010e'
        : colorMode == 'dark'
        ? '#6570c1'
        : '#2c3890',
  }

  const modules: { [key: string]: ReactElement } = {
    header: <TextWidth><MiniHeader /></TextWidth>,
    list: <List />,
    summary: <Summary personId={properties.personId} />,
    chart: <div>CHART</div>,
  }

  return (
    <AppContainer colorMode={colorMode}>
      {/* <div style={{height: '20vh'}} /> */}
      <ThemeProvider theme={theme}>{modules[properties.module]}</ThemeProvider>
      {/* <div style={{height: '200vh'}} /> */}
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

export default MainComponent
